export default __webpack_public_path__ + "1d1b8be2a0c741241fc08c59aba4a40a.svg";